import React from 'react'
import PropTypes from 'prop-types'
// import { View, ImageBackground, StyleSheet } from 'react-native'
import { Spacing } from '../../global'
import { View } from '../../Components'
import { Image } from 'antd'

const styles = {
  backgroundImg: {
    flex: 1,
    height: '100%',
    position: 'absolute',
    width: '100%',
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    padding: 0,//Spacing.lg,
    paddingTop: 0,//Spacing.md,
    // paddingBottom: '5%',
    height: '100%',
    width: '100%',
  },
  footer: {
    alignItems: 'flex-end',
    flex: 1,
    justifyContent: 'flex-end',
    width: '100%',
  },
  head: {
    flex: 0,
    flexGrow: 0,
    flexDirection: 'column',
    height: 'auto',
    paddingLeft: Spacing.lg,
    paddingRight: Spacing.lg,
    width: '100%',
    justifyContent: 'flex-end',
  },
  wrapper: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    width: '100%',
  },
}

const Layout = ({ children, style, backgroundImage, ...rest }) => (
  <View {...rest} style={{ ...styles.wrapper, ...style }}>
    {backgroundImage && <Image source={backgroundImage} style={styles.backgroundImg} />}
    {children}
  </View>
)

Layout.Head = ({ children, style, ...rest }) => (
  <View {...rest} style={[styles.head, style]}>
    {children}
  </View>
)

Layout.Content = ({ children, style, ...rest }) => (
  <View {...rest} style={[styles.content, style]}>
    {children}
  </View>
)

Layout.Footer = ({ children, style, ...rest }) => (
  <View {...rest} style={[styles.footer, style]}>
    {children}
  </View>
)

Layout.Content.defaultProps = {
  padding: 'md',
  children: null,
  style: null,
}

Layout.Content.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  padding: PropTypes.oneOf(['sm', 'md', 'lg']),
}

Layout.displayName = 'content'

export default Layout
